import React from "react";
import styled, { withTheme } from "styled-components";
import StyledElement from "./StyledElement";
import PrimaryButton from "../../ui-library/Buttons/PrimaryButton/PrimaryButton";
import LoadingSpinner from "../../ui-library/LoadingSpinner/LoadingSpinner";
import { useTranslation } from "react-i18next";

const StyledPaper = styled.div`
  background-color: ${(props) => props.theme?.white};
  color: ${(props) => props.theme?.fg};
  box-shadow: 0px 0px 6px #00000029;
  border-radius: 12px;
  padding: 10px;
`;

const StyledHeader = styled.div`
  padding: 1rem 2rem 0.5rem 1rem;
  margin-bottom: 0;
  border-bottom: 0px solid rgba(0, 0, 0, 0.125);
  font-size: 19px;
  font-weight: 600;
  color: ${(props) => props.theme?.nero};

  @media (max-width: 647px) {
    font-size: 14px;
  }
`;

const StyledDivButton = styled.div`
  padding: 1rem 1rem 0rem 0rem;
  margin-bottom: 0;

  @media (max-width: 647px) {
    & > button {
      font-size: 14px;
      padding: 0.25rem;
    }
  }
`;

const StyledBody = styled.div`
  padding: 0.5rem 1rem 2rem 2rem;
  overflow-y: auto;
  max-height: 250px;
  margin-top: 5px;
  margin-right: 20px;
`;

const StyledDiv = styled.div`
  min-height: 2em;
  text-align: justify;
  border-radius: 5px;
  margin-top: 10px;
  background-color: ${(props) => props.theme?.whiteSmoke};
  padding-top: 0.2em;
`;

const FastedDayMessage = styled.div`
  min-height: 2em;
  border-radius: 5px;
  margin-top: 10px;
  background-color: ${(props) => props.theme?.whiteSmoke};
  padding-top: 0.2em;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding-left: 1rem;
  align-items: center;
  font-size: 16px;
`;

const CompleteIcon = styled.i`
  color: ${(props) =>
    props?.isFastingIcon
      ? props?.theme?.blueMagenta2
      : props?.theme?.lightGreen};
  font-size: 20px;
  margin-right: 20px;
`;

const EntriesList = (props) => {
  const {
    id,
    title,
    elements,
    actionButtonText,
    actionButton,
    isFastingDay,
    actionButtonInactive,
    onEdit,
    canEdit,
    loadingEntries,
    loadingEntriesError,
    showActionButton,
  } = props;

  const { t } = useTranslation();

  return (
    <div id={id} data-testid={id}>
      <StyledPaper>
        <div className="d-flex">
          <StyledHeader className="">{title}</StyledHeader>

          {showActionButton && (
            <StyledDivButton className="ml-auto">
              <PrimaryButton
                size={"sm"}
                id={`${id}-action-btn`}
                data-testid={`${id}-action-btn`}
                onClick={() => actionButton(elements)}
                disabled={actionButtonInactive}
              >
                {actionButtonText}
              </PrimaryButton>
            </StyledDivButton>
          )}
        </div>
        <StyledBody className="align-middle">
          {loadingEntries && !loadingEntriesError && <LoadingSpinner />}
          {!isFastingDay &&
            elements?.map((elementEdit, index) => (
              <StyledElement
                key={index}
                index={index}
                element={elementEdit}
                onEdit={(elementEdit) => onEdit(elementEdit)}
                canEdit={canEdit}
              />
            ))}
          {isFastingDay && (
            <FastedDayMessage data-testid="fasting-day" className="row">
              <CompleteIcon
                className="fas fa-check-circle"
                isFastingIcon={true}
              />{" "}
              {t("appText.fastingDay")}
            </FastedDayMessage>
          )}
          {!isFastingDay &&
            (loadingEntriesError || !elements || elements.length === 0) && (
              <StyledDiv data-testid="no-records" className="row">
                {t("appText.noRecords")}
              </StyledDiv>
            )}
        </StyledBody>
      </StyledPaper>
    </div>
  );
};

export default withTheme(EntriesList);
